// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__168h3","bigColWidth":"Table_bigColWidth__1mb_-","biggerColWidth":"Table_biggerColWidth__2d671","row":"Table_row__SvV9i","col":"Table_col__3ZlTC"};